import { useTranslation } from "react-i18next";
import Skeleton from "react-loading-skeleton";
import RecordNotFound from "../../../shared/recordNotFound";

type AssignedItem = Record<string, any>;

type ActiveOption = {
  assigned_items?: AssignedItem[];
} | null;

type ActiveOptionInfoProps = {
  activeOption: ActiveOption;
  getTranslatedKey: (key: string, item: AssignedItem) => string;
  handleDeleteFromAssigned: (item: AssignedItem) => void;
  listLength: number;
  loader: boolean;
  onAssign: () => void;
};

const ActiveOptionInfo = ({ activeOption, getTranslatedKey, handleDeleteFromAssigned, listLength, loader, onAssign }: ActiveOptionInfoProps) => {
  const { t } = useTranslation();

  return (
    <div className="card">
      <div className="card-body">
        {loader ? (
          <div className="w-100">
            <Skeleton className="mb-2" height={50} count={5} />
          </div>
        ) : activeOption?.assigned_items?.length ? (
          <div className="table-responsive" style={{ minHeight: "auto" }}>
            <table className="table option-items-table">
              <thead>
                <tr>
                  <th>{t("product_name")}</th>
                  <th>{t("label_price_tax_included")}</th>
                  <th>{t("label_max_quantity")}</th>
                  <th style={{ width: "100px" }}>{t("label_action")}</th>
                </tr>
              </thead>
              <tbody>
                {(activeOption.assigned_items || []).map((item, index) => (
                    <tr key={item?._id || index}>
                      <td title={getTranslatedKey("item_name", item)}>
                        <span className="option-item-product-name">
                          {getTranslatedKey("item_name", item)}
                        </span>
                      </td>
                      <td>¥ {item?.price ?? "-"}</td>
                      <td>{item?.max_quantity ?? t("label_no_limit")}</td>
                      <td>
                        <button className="btn btn-icon" onClick={() => handleDeleteFromAssigned(item)}>
                          <i className="ti ti-trash"></i>
                        </button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        ) : (
          <RecordNotFound heading="no_assigned_item_text" />
        )}
        {listLength && !loader ? (
          <div className="text-center active-option-assign-actions">
            <button className="btn btn-primary" data-bs-toggle="offcanvas" data-bs-target="#assign-items-canvas" onClick={onAssign}>
              {t("label_assign_items")}
            </button>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default ActiveOptionInfo;
